import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import './css/copilotStyle.css'
// import LandingPage from './pages/LandingPage';
import EarthLayers from "./pages/EarthLayers";

function App() {
  return (
    <Router>
      <EarthLayers/>
    </Router>
  );
}

export default App;
